import { Injectable, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  resumeEvent = new Subject<boolean>();
  orientationChangeEvent = new Subject<boolean>();
  deviceId = '';

  constructor() { }

  triggerResumeEvent() {
    this.resumeEvent.next(true);
  }

  onAppResume() {
    return this.resumeEvent.asObservable();
  }

  async getDeviceId() {
    const info = await Device.getId();
    this.deviceId = info.identifier;
  }
}
